import { Breakpoint } from '@mui/system'
import { breakpoints } from '../constants/breakpoints'

export const maxWidth = (breakpoint: Breakpoint) => `(max-width: ${breakpoints[breakpoint]}px)`
